module.exports = __webpack_public_path__ + "img/52.3e792c22.png";